import {
  Row,
  Col,
  Alert,
  Popconfirm,
  Button,
  Radio,
  message,
  Collapse,
  ConfigProvider,
  Badge,
  Spin,
  Result,
} from "antd";

// import axios from "axios";
import { LIST_FORMS } from "../../literals";
import { jsPDF } from "jspdf";
import { useEffect, useState, useRef } from "react";
import AnswerCall from "../GuidedFlowTracker/AnswerCall";
import Registration from "../GuidedFlowTracker/Registration";
import TANFWPCOOP from "../GuidedFlowTracker/TANF_WPCOOP";
import CHILDCAREONLY from "../GuidedFlowTracker/ChildCare";
import CC_TANF from "../GuidedFlowTracker/CC_TANF";
import TANFDT from "../GuidedFlowTracker/Tanf_DT";
import ScreenNameVR from "../GuidedFlowTracker/ScreenName_VR";
import ScreenNamePW from "../GuidedFlowTracker/ScreenName_PW";
import moment from "moment";
import CS_ALL_PROGRAMS from "../GuidedFlowTracker/CS_AllPrograms";
import CS_AUTHREP from "../GuidedFlowTracker/CS_AuthRep";
import CS_SUMMARY_SCREEN from "../GuidedFlowTracker/CS_SummaryScreen";
import INDEMOSCREEN from "../GuidedFlowTracker/IDS";
import CITIDENTITYLIST from "../GuidedFlowTracker/CIL";
import HOUSEHOLDSTATUSLIST from "../GuidedFlowTracker/HS_StatusList";
import RELATIONSHIPLIST from "../GuidedFlowTracker/RelationshipList";
import PREGNANCYLIST from "../GuidedFlowTracker/PregnancyList";
import OTHERPROGRAMLIST from "../GuidedFlowTracker/OtherProgramList";
import NONCOMPLIANCELIST from "../GuidedFlowTracker/NC_List";
import TIMELIMITSUMMARY from "../GuidedFlowTracker/TimeLimitSummary";
import PURCHASEPREPARELIST from "../GuidedFlowTracker/PP_List";
import SCHOOLATTLIST from "../GuidedFlowTracker/SA_List";
import LIVINGARRANGEMENT from "../GuidedFlowTracker/LivingArrangement";
import NONCUSTPARENTLIST from "../GuidedFlowTracker/NC_ParentList";
import MEDCONDLIST from "../GuidedFlowTracker/MC_List";
import EMPLISTINCLIST from "../GuidedFlowTracker/EL_IncomeList";
import RESOURCELIST from "../GuidedFlowTracker/ResourceList";
import EXPENSELIST from "../GuidedFlowTracker/ExpenseList";
import DCEXPENSELIST from "../GuidedFlowTracker/DC_ExpenseList";
import MDEXPENSELIST from "../GuidedFlowTracker/MD_ExpenseList";
import MDCAREEXPENSELIST from "../GuidedFlowTracker/MDC_ExpenseList";
import CHILDCARENEEDLIST from "../GuidedFlowTracker/CC_NeedList";
import PCSCHEDULEDLIST from "../GuidedFlowTracker/PC_ScheduleList";
import FAMPLANCHILDCARE from "../GuidedFlowTracker/FP_ChildCareList";
import TANFSUSPENSIONBASED from "../GuidedFlowTracker/SB_TANF";
import DVSASS from "../GuidedFlowTracker/DVSA_StalkingScreening";
import ICEBT from "../GuidedFlowTracker/IC_EBT";
import EXPEDITEDSTATUS from "../GuidedFlowTracker/IC_ExpeditedStatus";
import ICMAWRS from "../GuidedFlowTracker/IC_MAWRS";
import VERIFICATIONSLIST from "../GuidedFlowTracker/VerificationsList";
import TODO from "../GuidedFlowTracker/TODO";
import RUNEDBC from "../GuidedFlowTracker/RunEDBC";
import NARRATIVE from "../GuidedFlowTracker/Narrative";
// import AnswerCall from "../GuidedFlowTracker/AnswerCall";
import RightsAndResponsibilities from "../GuidedFlowTracker/RightsAndResp";
import ReportingPage from "../GuidedFlowTracker/ReportingPage";
import useFormFetch from "../../hooks/useFormFetch";
import { LAMBDAS } from "../../literals";
import {
  setErrorCount_answer_call_form,
  setErrorCount_right_resp_form,
  setErrorCount_registration_form,
  setErrorCount_tanfdt_form,
  setErrorCount_cctanf_form,
  setErrorCount_tanfwpcoop_form,
  setErrorCount_childcareonly_form,
  setErrorCount_screenvr_form,
  setErrorCount_screenpw_form,
  setErrorCount_csallprograms_form,
  setErrorCount_csauthrep_form,
  setErrorCount_cssummaryscreen_form,
  setErrorCount_reportingpage_form,
  setErrorCount_indemoscreen_form,
  setErrorCount_citidentitylist_form,
  setErrorCount_householdstatuslist_form,
  setErrorCount_relationshiplist_form,
  setErrorCount_pregnancylist_form,
  setErrorCount_otherprogramlist_form,
  setErrorCount_noncompliancelist_form,
  setErrorCount_timelimitsummary_form,
  setErrorCount_purchasepreparelist_form,
  setErrorCount_schoolattlist_form,
  setErrorCount_livingarrangement_form,
  setErrorCount_noncustparentlist_form,
  setErrorCount_medcondlist_form,
  setErrorCount_emplistinclist_form,
  setErrorCount_resourcelist_form,
  setErrorCount_expenselist_form,
  setErrorCount_dcexpenselist_form,
  setErrorCount_mdexpenselist_form,
  setErrorCount_mdcareexpenselist_form,
  setErrorCount_childcareneedlist_form,
  setErrorCount_pcscheduledlist_form,
  setErrorCount_famplanchildcare_form,
  setErrorCount_tanfsuspensionbased_form,
  setErrorCount_dvsass_form,
  setErrorCount_icebt_form,
  setErrorCount_expeditedstatus_form,
  setErrorCount_icmawrs_form,
  setErrorCount_verificationslist_form,
  setErrorCount_todo_form,
  setErrorCount_runedbc_form,
  setErrorCount_narrative_form,

  // update_isSuccess,
  // update_interview_form_data,
} from "../../actions/tracker_slice";
import { useDispatch, useSelector } from "react-redux";
import dcf_logo from "../images/DCF_logo.png";

const { Panel } = Collapse;
// let datasource = [];
// let datasourceList = [];

const SupervisorViewList = ({
  dataToEdit,
  lastAgentUpdate,
  isEditing,
  fileName,
  contactId,
  caseNumber,
  agentName,
}) => {
  // const temp_data_form_ref = useRef();
  const answer_call_form_ref = useRef();
  const right_resp_form_ref = useRef();
  const registration_form_ref = useRef();
  const tanfdt_form_ref = useRef();
  const tanfwpcoop_form_ref = useRef();
  const childcareonly_form_ref = useRef();
  const cctanf_form_ref = useRef();
  const screennamevr_form_ref = useRef();
  const screennamepw_form_ref = useRef();
  const csallprograms_form_ref = useRef();
  const csauthrep_form_ref = useRef();
  const cssummaryscreen_form_ref = useRef();
  const reportingpage_form_ref = useRef();
  const indemoscreen_form_ref = useRef();
  const citidentitylist_form_ref = useRef();
  const householdstatuslist_form_ref = useRef();
  const relationshiplist_form_ref = useRef();
  const pregnancylist_form_ref = useRef();
  const otherprogramlist_form_ref = useRef();
  const noncompliancelist_form_ref = useRef();
  const timelimitsummary_form_ref = useRef();
  const purchasepreparelist_form_ref = useRef();
  const schoolattlist_form_ref = useRef();
  const livingarrangement_form_ref = useRef();
  const noncustparentlist_form_ref = useRef();
  const medcondlist_form_ref = useRef();
  const emplistinclist_form_ref = useRef();
  const resourcelist_form_ref = useRef();
  const expenselist_form_ref = useRef();
  const dcexpenselist_form_ref = useRef();
  const mdexpenselist_form_ref = useRef();
  const mdcareexpenselist_form_ref = useRef();
  const childcareneedlist_form_ref = useRef();
  const pcscheduledlist_form_ref = useRef();
  const famplanchildcare_form_ref = useRef();
  const tanfsuspensionbased_form_ref = useRef();
  const dvsass_form_ref = useRef();
  const icebt_form_ref = useRef();
  const expeditedstatus_form_ref = useRef();
  const icmawrs_form_ref = useRef();
  const verificationslist_form_ref = useRef();
  const todo_form_ref = useRef();
  const runedbc_form_ref = useRef();
  const narrative_form_ref = useRef();
  const dispatch = useDispatch();
  const [interview_data, setInterviewData] = useState([]);
  const [is_contact_loading, set_contact_loading] = useState(true);
  const [isSuccess, setSuccess] = useState(false);
  const [documentName, setDocumentName] = useState("");
  const [callAnswered, setCallAnswered] = useState("");
  const [assessmentForm, setAssessmentForm] = useState(false);
  const [payLoad, setpayLoad] = useState(null);
  const [completed, setCompleted] = useState("");
  const [getLastAgentUpdate, setLastAgentUpdate] = useState({
    "Last Update Details": [],
  });
  const [collapse_active_keys, set_collapse_active_keys] = useState([
    "1",
    "2",
    "3",
    "4",
    "5",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12",
    "13",
    "14",
  ]);
  const intervalId = useRef(null);

  const answer_call_form_error_count = useSelector(
    (state) => state.tracker.answer_call_form_type
  );
  const right_resp_form_error_count = useSelector(
    (state) => state.tracker.right_resp_form_type
  );

  const registration_form_error_count = useSelector(
    (state) => state.tracker.registration_form_type
  );

  const tanfdt_form_error_count = useSelector(
    (state) => state.tracker.tanfdt_form_type
  );

  const tanfwpcoop_form_error_count = useSelector(
    (state) => state.tracker.tanfwpcoop_form_type
  );

  const childcareonly_form_error_count = useSelector(
    (state) => state.tracker.childcareonly_form_type
  );

  const cctanf_form_error_count = useSelector(
    (state) => state.tracker.cctanf_form_type
  );

  const screenvr_form_error_count = useSelector(
    (state) => state.tracker.screennamevr_form_type
  );

  const screenpw_form_error_count = useSelector(
    (state) => state.tracker.screennamepw_form_type
  );

  const csallprograms_form_error_count = useSelector(
    (state) => state.tracker.csallprograms_form_type
  );

  const csauthrep_form_error_count = useSelector(
    (state) => state.tracker.csauthrep_form_type
  );

  const cssummaryscreen_form_error_count = useSelector(
    (state) => state.tracker.cssummaryscreen_form_type
  );

  const reportingpage_form_error_count = useSelector(
    (state) => state.tracker.reportingpage_form_type
  );

  const indemoscreen_form_error_count = useSelector(
    (state) => state.tracker.indemoscreen_form_type
  );

  const citidentitylist_form_error_count = useSelector(
    (state) => state.tracker.citidentitylist_form_type
  );
  const householdstatuslist_form_error_count = useSelector(
    (state) => state.tracker.householdstatuslist_form_type
  );

  const relationshiplist_form_error_count = useSelector(
    (state) => state.tracker.relationshiplist_form_type
  );

  const pregnancylist_form_error_count = useSelector(
    (state) => state.tracker.pregnancylist_form_type
  );

  const otherprogramlist_form_error_count = useSelector(
    (state) => state.tracker.otherprogramlist_form_type
  );

  const noncompliancelist_form_error_count = useSelector(
    (state) => state.tracker.noncompliancelist_form_type
  );

  const timelimitsummary_form_error_count = useSelector(
    (state) => state.tracker.timelimitsummary_form_type
  );

  const purchasepreparelist_form_error_count = useSelector(
    (state) => state.tracker.purchasepreparelist_form_type
  );

  const schoolattlist_form_error_count = useSelector(
    (state) => state.tracker.schoolattlist_form_type
  );

  const livingarrangement_form_error_count = useSelector(
    (state) => state.tracker.livingarrangement_form_type
  );

  const noncustparentlist_form_error_count = useSelector(
    (state) => state.tracker.noncustparentlist_form_type
  );

  const medcondlist_form_error_count = useSelector(
    (state) => state.tracker.medcondlist_form_type
  );

  const emplistinclist_form_error_count = useSelector(
    (state) => state.tracker.emplistinclist_form_type
  );
  const resourcelist_form_error_count = useSelector(
    (state) => state.tracker.resourcelist_form_type
  );
  const expenselist_form_error_count = useSelector(
    (state) => state.tracker.expenselist_form_type
  );

  const dcexpenselist_form_error_count = useSelector(
    (state) => state.tracker.dcexpenselist_form_type
  );
  const mdexpenselist_form_error_count = useSelector(
    (state) => state.tracker.mdexpenselist_form_type
  );

  const mdcareexpenselist_form_error_count = useSelector(
    (state) => state.tracker.mdcareexpenselist_form_type
  );

  const childcareneedlist_form_error_count = useSelector(
    (state) => state.tracker.childcareneedlist_form_type
  );

  const pcscheduledlist_form_error_count = useSelector(
    (state) => state.tracker.pcscheduledlist_form_type
  );

  const famplanchildcare_form_error_count = useSelector(
    (state) => state.tracker.famplanchildcare_form_type
  );

  const tanfsuspensionbased_form_error_count = useSelector(
    (state) => state.tracker.tanfsuspensionbased_form_type
  );

  const dvsass_form_error_count = useSelector(
    (state) => state.tracker.dvsass_form_type
  );

  const icebt_form_error_count = useSelector(
    (state) => state.tracker.icebt_form_type
  );

  const expeditedstatus_form_error_count = useSelector(
    (state) => state.tracker.expeditedstatus_form_type
  );
  const icmawrs_form_error_count = useSelector(
    (state) => state.tracker.icmawrs_form_type
  );
  const verificationslist_form_error_count = useSelector(
    (state) => state.tracker.verificationslist_form_type
  );

  const todo_form_error_count = useSelector(
    (state) => state.tracker.todo_form_type
  );

  const runedbc_form_error_count = useSelector(
    (state) => state.tracker.runedbc_form_type
  );

  const narrative_form_error_count = useSelector(
    (state) => state.tracker.narrative_form_type
  );

  const current_agent_name = useSelector((state) => state.tracker.agent_name);
  // const isSuccessDisplay = useSelector((state) => state.tracker.isSuccess);

  // const answer_call_form_details = useSelector(
  //   (state) => state.tracker.answer_call_form_type
  // );
  // const right_resp_form_details = useSelector(
  //   (state) => state.tracker.right_resp_form_type
  // );

  // const registration_form_details = useSelector(
  //   (state) => state.tracker.registration_form_type
  // );

  // const tanfdt_form_details = useSelector(
  //   (state) => state.tracker.tanfdt_form_type
  // );

  const autosave = () => {
    console.log("[autosave][supervisor]");

    const auto_save_forms = [
      // {
      //   "Caller Details": {
      //     "Contact Id": contactID,
      //     "Call Answered": callAnswered,
      //   },
      // },

      {
        "TANF/CC/FOOD ASSISTANCE PROGRAM":
          answer_call_form_ref.current.getFieldsValue(),
      },
      {
        "RIGHTS AND RESPONSIBILITIES":
          right_resp_form_ref.current.getFieldsValue(),
      },
      {
        REGISTRATION: registration_form_ref.current.getFieldsValue(),
      },
      {
        "TANF Drug Testing Program Requirements":
          tanfdt_form_ref.current.getFieldsValue(),
      },
      {
        "TANF ONLY and WORK PROGRAM COOP":
          tanfwpcoop_form_ref.current.getFieldsValue(),
      },
      {
        "CHILD CARE ONLY": childcareonly_form_ref.current.getFieldsValue(),
      },
      {
        "CC/TANF ONLY": cctanf_form_ref.current.getFieldsValue(),
      },
      {
        "VOTER REGISTRATION": screennamevr_form_ref.current.getFieldsValue(),
      },
      {
        "PROGRAM WITHDRAW": screennamepw_form_ref.current.getFieldsValue(),
      },
      {
        "CASE SUMMARY (All Programs)":
          csallprograms_form_ref.current.getFieldsValue(),
      },
      {
        "AUTHORIZED REP": csauthrep_form_ref.current.getFieldsValue(),
      },
      {
        "CONTACT SUMMARY SCREEN (All Programs)":
          cssummaryscreen_form_ref.current.getFieldsValue(),
      },
      {
        "REPORTING PAGE (Reviews/IR ONLY)":
          reportingpage_form_ref.current.getFieldsValue(),
      },
      {
        "INDIVIDUAL DEMOGRAPHICS SCREEN (All Programs)":
          indemoscreen_form_ref.current.getFieldsValue(),
      },
      {
        "CITIZENSHIP/ IDENTITY LIST (All Programs)":
          citidentitylist_form_ref.current.getFieldsValue(),
      },
      {
        "HOUSEHOLD STATUS LIST":
          householdstatuslist_form_ref.current.getFieldsValue(),
      },
      {
        "RELATIONSHIP LIST (All Programs)":
          relationshiplist_form_ref.current.getFieldsValue(),
      },
      {
        "PREGNANCY LIST (All Programs)":
          pregnancylist_form_ref.current.getFieldsValue(),
      },
      {
        "OTHER PROGRAM LIST (All Programs)":
          otherprogramlist_form_ref.current.getFieldsValue(),
      },
      {
        "NON-COMPLIANCE LIST (All Programs)":
          noncompliancelist_form_ref.current.getFieldsValue(),
      },
      {
        "TIME LIMIT SUMMARY (All Programs)":
          timelimitsummary_form_ref.current.getFieldsValue(),
      },
      {
        "PURCHASE AND PREPARE LIST (FA)":
          purchasepreparelist_form_ref.current.getFieldsValue(),
      },
      {
        "SCHOOL ATTENDANCE LIST (All Programs)":
          schoolattlist_form_ref.current.getFieldsValue(),
      },
      {
        "LIVING ARRANGEMENTS":
          livingarrangement_form_ref.current.getFieldsValue(),
      },
      {
        "NONCUSTODIAL PARENT LIST (All Programs)":
          noncustparentlist_form_ref.current.getFieldsValue(),
      },
      {
        "MEDICAL CONDITION LIST (FA, TANF)":
          medcondlist_form_ref.current.getFieldsValue(),
      },
      {
        "EMPLOYMENT LIST /INCOME LIST":
          emplistinclist_form_ref.current.getFieldsValue(),
      },
      {
        "RESOURCE LIST (All Programs)":
          resourcelist_form_ref.current.getFieldsValue(),
      },
      {
        "SHELTER - EXPENSE LIST (FA, TANF)":
          expenselist_form_ref.current.getFieldsValue(),
      },
      {
        "DEPENDENT CARE/ CSS - EXPENSE LIST (FA, TANF)":
          dcexpenselist_form_ref.current.getFieldsValue(),
      },
      {
        "MEDICAL - EXPENSE LIST (FA, TANF)":
          mdexpenselist_form_ref.current.getFieldsValue(),
      },
      {
        "MEDICARE EXPENSE LIST (FA Only)":
          mdcareexpenselist_form_ref.current.getFieldsValue(),
      },
      {
        "CHILD CARE NEED LIST – PARENT AND/ OR CHILD CARE NEED LIST – CHILD (CC Only)":
          childcareneedlist_form_ref.current.getFieldsValue(),
      },
      {
        "PARENT SCHEDULE LIST AND/ OR CHILD SCHEDULE LIST (CC Only)":
          pcscheduledlist_form_ref.current.getFieldsValue(),
      },
      {
        "FAMILY PLAN – CHILD CARE LIST (CC Only)":
          famplanchildcare_form_ref.current.getFieldsValue(),
      },
      {
        "TANF Suspicion Based Drug Testing (Only those who meet suspicion-based indicators)":
          tanfsuspensionbased_form_ref.current.getFieldsValue(),
      },
      {
        "DOMESTIC VIOLENCE, SEXUAL ASSAULT, OR STALKING SCREENING (REQUIRED)":
          dvsass_form_ref.current.getFieldsValue(),
      },
      {
        EBT: icebt_form_ref.current.getFieldsValue(),
      },
      {
        "EXPEDITED STATUS": expeditedstatus_form_ref.current.getFieldsValue(),
      },
      {
        "MANDATORY ABAWD / E&T / WORK REGISTRANT SCRIPTS":
          icmawrs_form_ref.current.getFieldsValue(),
      },
      {
        "VERIFICATIONS LIST":
          verificationslist_form_ref.current.getFieldsValue(),
      },
      {
        TODO: todo_form_ref.current.getFieldsValue(),
      },
      {
        "RUN EDBC": runedbc_form_ref.current.getFieldsValue(),
      },
      {
        NARRATIVE: narrative_form_ref.current.getFieldsValue(),
      },
      getLastAgentUpdate,
    ];

    let contact_name =
      answer_call_form_ref.current.getFieldValue("Client Name");
    let contact_number =
      answer_call_form_ref.current.getFieldValue("Callback Number");
    const cDate = new Date();
    let dateNTimestampFormat =
      cDate.getFullYear() +
      "-" +
      String(cDate.getMonth() + 1).padStart(2, 0) +
      "-" +
      String(cDate.getDate()).padStart(2, 0) +
      "_" +
      Math.floor(cDate.getTime() / 1000);
    let file_name =
      "KEES Case^Journaling^" +
      caseNumber +
      "^" +
      contact_name +
      "^" +
      dateNTimestampFormat;
    // let file_name = currentFileID + "_" + current_agent_name.replace(/ /g, "");
    // props.agentName.toLowerCase().replace(/ /g, "");
    console.log("[autosave][supervisor send]");
    let isAutosave = true;
    sendContactDetails(
      file_name,
      contact_name,
      contact_number,
      auto_save_forms,
      isAutosave
    );
  };

  useEffect(() => {
    setLastAgentUpdate(lastAgentUpdate);
    populate_form(dataToEdit);
    set_contact_loading(false);

    if (dataToEdit) {
      intervalId.current = setInterval(autosave, 60000);

      // autosave();
    } else {
      clearInterval(intervalId.current);
    }
    return () => clearInterval(intervalId.current);

    // setTimeout(() => {

    // }, 5000);
  }, [dataToEdit]);
  useEffect(() => {
    if (assessmentForm) {
      clearInterval(intervalId.current);
    }
  }, [assessmentForm]);

  const onValuesChange_answer_call_form = (formData) => {
    if (assessmentForm) {
      answer_call_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_answer_call_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_answer_call_form(error.errorFields.length));
        });
    }

    // const errors = Object.values(formData).filter((val) => !val).length;
  };

  const onValuesChange_right_resp_form = (formData) => {
    if (assessmentForm) {
      right_resp_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_right_resp_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_right_resp_form(error.errorFields.length));
        });
    }

    // const errors = Object.values(formData).filter((val) => !val).length;
    // dispatch(setErrorCount_right_resp_form(errors));
  };

  const onValuesChange_registration_form = (formData) => {
    if (assessmentForm) {
      registration_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_registration_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_registration_form(error.errorFields.length));
        });
    }
  };

  const onValuesChange_tanfdt_form = (formData) => {
    if (assessmentForm) {
      tanfdt_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_tanfdt_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_tanfdt_form(error.errorFields.length));
        });
      tanfwpcoop_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_tanfwpcoop_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_tanfwpcoop_form(error.errorFields.length));
        });
      childcareonly_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_childcareonly_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_childcareonly_form(error.errorFields.length));
        });
      cctanf_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_cctanf_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_cctanf_form(error.errorFields.length));
        });
    }
  };

  const onValuesChange_tanfwpcoop_form = (formData) => {
    if (assessmentForm) {
      tanfdt_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_tanfdt_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_tanfdt_form(error.errorFields.length));
        });
      tanfwpcoop_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_tanfwpcoop_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_tanfwpcoop_form(error.errorFields.length));
        });
      childcareonly_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_childcareonly_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_childcareonly_form(error.errorFields.length));
        });
      cctanf_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_cctanf_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_cctanf_form(error.errorFields.length));
        });
    }
  };

  const onValuesChange_childcareonly_form = (formData) => {
    if (assessmentForm) {
      tanfdt_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_tanfdt_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_tanfdt_form(error.errorFields.length));
        });
      tanfwpcoop_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_tanfwpcoop_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_tanfwpcoop_form(error.errorFields.length));
        });
      childcareonly_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_childcareonly_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_childcareonly_form(error.errorFields.length));
        });
      cctanf_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_cctanf_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_cctanf_form(error.errorFields.length));
        });
    }
  };

  const onValuesChange_cctanf_form = (formData) => {
    if (assessmentForm) {
      tanfdt_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_tanfdt_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_tanfdt_form(error.errorFields.length));
        });
      tanfwpcoop_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_tanfwpcoop_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_tanfwpcoop_form(error.errorFields.length));
        });
      childcareonly_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_childcareonly_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_childcareonly_form(error.errorFields.length));
        });
      cctanf_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_cctanf_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_cctanf_form(error.errorFields.length));
        });
    }
  };

  const onValuesChange_screennamevr_form = (formData) => {
    if (assessmentForm) {
      screennamevr_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_screenvr_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_screenvr_form(error.errorFields.length));
        });
      screennamepw_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_screenpw_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_screenpw_form(error.errorFields.length));
        });
    }
  };

  const onValuesChange_screennamepw_form = (formData) => {
    if (assessmentForm) {
      screennamevr_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_screenvr_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_screenvr_form(error.errorFields.length));
        });
      screennamepw_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_screenpw_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_screenpw_form(error.errorFields.length));
        });
    }
  };
  const onValuesChange_csallprograms_form = (formData) => {
    if (assessmentForm) {
      csallprograms_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_csallprograms_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_csallprograms_form(error.errorFields.length));
        });

      csauthrep_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_csauthrep_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_csauthrep_form(error.errorFields.length));
        });
    }
  };

  const onValuesChange_csauthrep_form = (formData) => {
    if (assessmentForm) {
      csauthrep_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_csauthrep_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_csauthrep_form(error.errorFields.length));
        });
      csallprograms_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_csallprograms_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_csallprograms_form(error.errorFields.length));
        });
    }
  };

  const onValuesChange_cssummaryscreen_form = (formData) => {
    if (assessmentForm) {
      cssummaryscreen_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_cssummaryscreen_form(0));
        })
        .catch((error) => {
          dispatch(
            setErrorCount_cssummaryscreen_form(error.errorFields.length)
          );
        });
      reportingpage_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_reportingpage_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_reportingpage_form(error.errorFields.length));
        });
      indemoscreen_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_indemoscreen_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_indemoscreen_form(error.errorFields.length));
        });
      citidentitylist_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_citidentitylist_form(0));
        })
        .catch((error) => {
          dispatch(
            setErrorCount_citidentitylist_form(error.errorFields.length)
          );
        });
      householdstatuslist_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_householdstatuslist_form(0));
        })
        .catch((error) => {
          dispatch(
            setErrorCount_householdstatuslist_form(error.errorFields.length)
          );
        });
      relationshiplist_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_relationshiplist_form(0));
        })
        .catch((error) => {
          dispatch(
            setErrorCount_relationshiplist_form(error.errorFields.length)
          );
        });
      pregnancylist_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_pregnancylist_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_pregnancylist_form(error.errorFields.length));
        });
      otherprogramlist_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_otherprogramlist_form(0));
        })
        .catch((error) => {
          dispatch(
            setErrorCount_otherprogramlist_form(error.errorFields.length)
          );
        });
      noncompliancelist_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_noncompliancelist_form(0));
        })
        .catch((error) => {
          dispatch(
            setErrorCount_noncompliancelist_form(error.errorFields.length)
          );
        });
      timelimitsummary_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_timelimitsummary_form(0));
        })
        .catch((error) => {
          dispatch(
            setErrorCount_timelimitsummary_form(error.errorFields.length)
          );
        });
      purchasepreparelist_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_purchasepreparelist_form(0));
        })
        .catch((error) => {
          dispatch(
            setErrorCount_purchasepreparelist_form(error.errorFields.length)
          );
        });
      schoolattlist_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_schoolattlist_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_schoolattlist_form(error.errorFields.length));
        });
      livingarrangement_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_livingarrangement_form(0));
        })
        .catch((error) => {
          dispatch(
            setErrorCount_livingarrangement_form(error.errorFields.length)
          );
        });
      noncustparentlist_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_noncustparentlist_form(0));
        })
        .catch((error) => {
          dispatch(
            setErrorCount_noncustparentlist_form(error.errorFields.length)
          );
        });
      medcondlist_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_medcondlist_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_medcondlist_form(error.errorFields.length));
        });
    }
  };

  const onValuesChange_emplistinclist_form = (formData) => {
    if (assessmentForm) {
      emplistinclist_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_emplistinclist_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_emplistinclist_form(error.errorFields.length));
        });
      resourcelist_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_resourcelist_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_resourcelist_form(error.errorFields.length));
        });
    }
  };

  const onValuesChange_expenselist_form = (formData) => {
    if (assessmentForm) {
      expenselist_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_expenselist_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_expenselist_form(error.errorFields.length));
        });
    }
  };
  const onValuesChange_dcexpenselist_form = (formData) => {
    if (assessmentForm) {
      dcexpenselist_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_dcexpenselist_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_dcexpenselist_form(error.errorFields.length));
        });
    }
  };
  const onValuesChange_mdexpenselist_form = (formData) => {
    if (assessmentForm) {
      mdexpenselist_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_mdexpenselist_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_mdexpenselist_form(error.errorFields.length));
        });
      mdcareexpenselist_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_mdcareexpenselist_form(0));
        })
        .catch((error) => {
          dispatch(
            setErrorCount_mdcareexpenselist_form(error.errorFields.length)
          );
        });
    }
  };
  const onValuesChange_childcareneedlist_form = (formData) => {
    if (assessmentForm) {
      childcareneedlist_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_childcareneedlist_form(0));
        })
        .catch((error) => {
          dispatch(
            setErrorCount_childcareneedlist_form(error.errorFields.length)
          );
        });
      pcscheduledlist_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_pcscheduledlist_form(0));
        })
        .catch((error) => {
          dispatch(
            setErrorCount_pcscheduledlist_form(error.errorFields.length)
          );
        });
      famplanchildcare_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_famplanchildcare_form(0));
        })
        .catch((error) => {
          dispatch(
            setErrorCount_famplanchildcare_form(error.errorFields.length)
          );
        });
      tanfsuspensionbased_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_tanfsuspensionbased_form(0));
        })
        .catch((error) => {
          dispatch(
            setErrorCount_tanfsuspensionbased_form(error.errorFields.length)
          );
        });
      dvsass_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_dvsass_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_dvsass_form(error.errorFields.length));
        });
    }
  };
  const onValuesChange_icebt_form = (formData) => {
    if (assessmentForm) {
      icebt_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_icebt_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_icebt_form(error.errorFields.length));
        });
      expeditedstatus_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_expeditedstatus_form(0));
        })
        .catch((error) => {
          dispatch(
            setErrorCount_expeditedstatus_form(error.errorFields.length)
          );
        });
      icmawrs_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_icmawrs_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_icmawrs_form(error.errorFields.length));
        });
      verificationslist_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_verificationslist_form(0));
        })
        .catch((error) => {
          dispatch(
            setErrorCount_verificationslist_form(error.errorFields.length)
          );
        });
      todo_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_todo_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_todo_form(error.errorFields.length));
        });
      runedbc_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_runedbc_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_runedbc_form(error.errorFields.length));
        });
    }
  };
  const onValuesChange_narrative_form = (formData) => {
    if (assessmentForm) {
      narrative_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_narrative_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_narrative_form(error.errorFields.length));
        });
    }
  };

  const getAllFormData = () => {
    setAssessmentForm(true);
    try {
      let interviewFormData = [
        {
          "Caller Details": {
            "Contact Id": contactId,
            "Call Answered": callAnswered,
          },
        },
      ];

      answer_call_form_ref.current
        .validateFields()
        .then((values) => {
          // setInterviewData();
          interviewFormData.push({ "TANF/CC/FOOD ASSISTANCE PROGRAM": values });
          dispatch(setErrorCount_answer_call_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "TANF/CC/FOOD ASSISTANCE PROGRAM": error.values,
          });
          dispatch(setErrorCount_answer_call_form(error.errorFields.length));
        });

      right_resp_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({ "RIGHTS AND RESPONSIBILITIES": values });
          dispatch(setErrorCount_right_resp_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "RIGHTS AND RESPONSIBILITIES": error.values,
          });
          dispatch(setErrorCount_right_resp_form(error.errorFields.length));
        });

      registration_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({ REGISTRATION: values });
          dispatch(setErrorCount_registration_form(0));
        })
        .catch((error) => {
          interviewFormData.push({ REGISTRATION: error.values });
          dispatch(setErrorCount_registration_form(error.errorFields.length));
        });

      tanfdt_form_ref.current
        .validateFields()
        .then((values) => {
          // values["Date of Conviction"] =
          //   values["Date of Conviction"].toISOString();
          values["Date of Conviction"] = moment(values["Date of Conviction"]);
          interviewFormData.push({
            "TANF Drug Testing Program Requirements": values,
          });
          dispatch(setErrorCount_tanfdt_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "TANF Drug Testing Program Requirements": error.values,
          });
          dispatch(setErrorCount_tanfdt_form(error.errorFields.length));
        });
      tanfwpcoop_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({ "TANF ONLY and WORK PROGRAM COOP": values });
          dispatch(setErrorCount_tanfwpcoop_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "TANF ONLY and WORK PROGRAM COOP": error.values,
          });
          dispatch(setErrorCount_tanfwpcoop_form(error.errorFields.length));
        });
      childcareonly_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({ "CHILD CARE ONLY": values });
          dispatch(setErrorCount_childcareonly_form(0));
        })
        .catch((error) => {
          interviewFormData.push({ "CHILD CARE ONLY": error.values });
          dispatch(setErrorCount_childcareonly_form(error.errorFields.length));
        });
      cctanf_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({ "CC/TANF ONLY": values });
          dispatch(setErrorCount_cctanf_form(0));
        })
        .catch((error) => {
          interviewFormData.push({ "CC/TANF ONLY": error.values });
          dispatch(setErrorCount_cctanf_form(error.errorFields.length));
        });
      screennamevr_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({ "VOTER REGISTRATION": values });
          dispatch(setErrorCount_screenvr_form(0));
        })
        .catch((error) => {
          interviewFormData.push({ "VOTER REGISTRATION": error.values });
          dispatch(setErrorCount_screenvr_form(error.errorFields.length));
        });
      screennamepw_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({ "PROGRAM WITHDRAW": values });
          dispatch(setErrorCount_screenpw_form(0));
        })
        .catch((error) => {
          interviewFormData.push({ "PROGRAM WITHDRAW": error.values });
          dispatch(setErrorCount_screenpw_form(error.errorFields.length));
        });
      csallprograms_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({ "CASE SUMMARY (All Programs)": values });
          dispatch(setErrorCount_csallprograms_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "CASE SUMMARY (All Programs)": error.values,
          });
          dispatch(setErrorCount_csallprograms_form(error.errorFields.length));
        });

      csauthrep_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({ "AUTHORIZED REP": values });
          dispatch(setErrorCount_csauthrep_form(0));
        })
        .catch((error) => {
          interviewFormData.push({ "AUTHORIZED REP": error.values });
          dispatch(setErrorCount_csauthrep_form(error.errorFields.length));
        });

      cssummaryscreen_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "CONTACT SUMMARY SCREEN (All Programs)": values,
          });
          dispatch(setErrorCount_cssummaryscreen_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "CONTACT SUMMARY SCREEN (All Programs)": error.values,
          });
          dispatch(
            setErrorCount_cssummaryscreen_form(error.errorFields.length)
          );
        });
      reportingpage_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "REPORTING PAGE (Reviews/IR ONLY)": values,
          });
          dispatch(setErrorCount_reportingpage_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "REPORTING PAGE (Reviews/IR ONLY)": error.values,
          });
          dispatch(setErrorCount_reportingpage_form(error.errorFields.length));
        });

      indemoscreen_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "INDIVIDUAL DEMOGRAPHICS SCREEN (All Programs)": values,
          });
          dispatch(setErrorCount_indemoscreen_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "INDIVIDUAL DEMOGRAPHICS SCREEN (All Programs)": error.values,
          });
          dispatch(setErrorCount_indemoscreen_form(error.errorFields.length));
        });

      citidentitylist_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "CITIZENSHIP/ IDENTITY LIST (All Programs)": values,
          });
          dispatch(setErrorCount_citidentitylist_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "CITIZENSHIP/ IDENTITY LIST (All Programs)": error.values,
          });
          dispatch(
            setErrorCount_citidentitylist_form(error.errorFields.length)
          );
        });
      householdstatuslist_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "HOUSEHOLD STATUS LIST": values,
          });
          dispatch(setErrorCount_householdstatuslist_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "HOUSEHOLD STATUS LIST": error.values,
          });
          dispatch(
            setErrorCount_householdstatuslist_form(error.errorFields.length)
          );
        });
      relationshiplist_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "RELATIONSHIP LIST (All Programs)": values,
          });
          dispatch(setErrorCount_relationshiplist_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "RELATIONSHIP LIST (All Programs)": error.values,
          });
          dispatch(
            setErrorCount_relationshiplist_form(error.errorFields.length)
          );
        });
      pregnancylist_form_ref.current
        .validateFields()
        .then((values) => {
          values["Due Date"] = moment(values["Due Date"]);
          interviewFormData.push({
            "PREGNANCY LIST (All Programs)": values,
          });
          dispatch(setErrorCount_pregnancylist_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "PREGNANCY LIST (All Programs)": error.values,
          });
          dispatch(setErrorCount_pregnancylist_form(error.errorFields.length));
        });
      otherprogramlist_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "OTHER PROGRAM LIST (All Programs)": values,
          });
          dispatch(setErrorCount_otherprogramlist_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "OTHER PROGRAM LIST (All Programs)": error.values,
          });
          dispatch(
            setErrorCount_otherprogramlist_form(error.errorFields.length)
          );
        });
      noncompliancelist_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "NON-COMPLIANCE LIST (All Programs)": values,
          });
          dispatch(setErrorCount_noncompliancelist_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "NON-COMPLIANCE LIST (All Programs)": error.values,
          });
          dispatch(
            setErrorCount_noncompliancelist_form(error.errorFields.length)
          );
        });
      timelimitsummary_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "TIME LIMIT SUMMARY (All Programs)": values,
          });
          dispatch(setErrorCount_timelimitsummary_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "TIME LIMIT SUMMARY (All Programs)": error.values,
          });
          dispatch(
            setErrorCount_timelimitsummary_form(error.errorFields.length)
          );
        });

      purchasepreparelist_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "PURCHASE AND PREPARE LIST (FA)": values,
          });
          dispatch(setErrorCount_purchasepreparelist_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "PURCHASE AND PREPARE LIST (FA)": error.values,
          });
          dispatch(
            setErrorCount_purchasepreparelist_form(error.errorFields.length)
          );
        });
      schoolattlist_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "SCHOOL ATTENDANCE LIST (All Programs)": values,
          });
          dispatch(setErrorCount_schoolattlist_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "SCHOOL ATTENDANCE LIST (All Programs)": error.values,
          });
          dispatch(setErrorCount_schoolattlist_form(error.errorFields.length));
        });
      livingarrangement_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "LIVING ARRANGEMENTS": values,
          });
          dispatch(setErrorCount_livingarrangement_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "LIVING ARRANGEMENTS": error.values,
          });
          dispatch(
            setErrorCount_livingarrangement_form(error.errorFields.length)
          );
        });
      noncustparentlist_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "NONCUSTODIAL PARENT LIST (All Programs)": values,
          });
          dispatch(setErrorCount_noncustparentlist_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "NONCUSTODIAL PARENT LIST (All Programs)": error.values,
          });
          dispatch(
            setErrorCount_noncustparentlist_form(error.errorFields.length)
          );
        });
      medcondlist_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "MEDICAL CONDITION LIST (FA, TANF)": values,
          });
          dispatch(setErrorCount_medcondlist_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "MEDICAL CONDITION LIST (FA, TANF)": error.values,
          });
          dispatch(setErrorCount_medcondlist_form(error.errorFields.length));
        });

      emplistinclist_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "EMPLOYMENT LIST /INCOME LIST": values,
          });
          dispatch(setErrorCount_emplistinclist_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "EMPLOYMENT LIST /INCOME LIST": error.values,
          });
          dispatch(setErrorCount_emplistinclist_form(error.errorFields.length));
        });
      resourcelist_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "RESOURCE LIST (All Programs)": values,
          });
          dispatch(setErrorCount_resourcelist_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "RESOURCE LIST (All Programs)": error.values,
          });
          dispatch(setErrorCount_resourcelist_form(error.errorFields.length));
        });
      expenselist_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "SHELTER - EXPENSE LIST (FA, TANF)": values,
          });
          dispatch(setErrorCount_expenselist_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "SHELTER - EXPENSE LIST (FA, TANF)": error.values,
          });
          dispatch(setErrorCount_expenselist_form(error.errorFields.length));
        });
      dcexpenselist_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "DEPENDENT CARE/ CSS - EXPENSE LIST (FA, TANF)": values,
          });
          dispatch(setErrorCount_dcexpenselist_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "DEPENDENT CARE/ CSS - EXPENSE LIST (FA, TANF)": error.values,
          });
          dispatch(setErrorCount_dcexpenselist_form(error.errorFields.length));
        });
      mdexpenselist_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "MEDICAL - EXPENSE LIST (FA, TANF)": values,
          });
          dispatch(setErrorCount_mdexpenselist_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "MEDICAL - EXPENSE LIST (FA, TANF)": error.values,
          });
          dispatch(setErrorCount_mdexpenselist_form(error.errorFields.length));
        });
      mdcareexpenselist_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "MEDICARE EXPENSE LIST (FA Only)": values,
          });
          dispatch(setErrorCount_mdcareexpenselist_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "MEDICARE EXPENSE LIST (FA Only)": error.values,
          });
          dispatch(
            setErrorCount_mdcareexpenselist_form(error.errorFields.length)
          );
        });
      childcareneedlist_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "CHILD CARE NEED LIST – PARENT AND/ OR CHILD CARE NEED LIST – CHILD (CC Only)":
              values,
          });
          dispatch(setErrorCount_childcareneedlist_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "CHILD CARE NEED LIST – PARENT AND/ OR CHILD CARE NEED LIST – CHILD (CC Only)":
              error.values,
          });
          dispatch(
            setErrorCount_childcareneedlist_form(error.errorFields.length)
          );
        });
      pcscheduledlist_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "PARENT SCHEDULE LIST AND/ OR CHILD SCHEDULE LIST (CC Only)":
              values,
          });
          dispatch(setErrorCount_pcscheduledlist_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "PARENT SCHEDULE LIST AND/ OR CHILD SCHEDULE LIST (CC Only)":
              error.values,
          });
          dispatch(
            setErrorCount_pcscheduledlist_form(error.errorFields.length)
          );
        });
      famplanchildcare_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "FAMILY PLAN – CHILD CARE LIST (CC Only)": values,
          });
          dispatch(setErrorCount_famplanchildcare_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "FAMILY PLAN – CHILD CARE LIST (CC Only)": error.values,
          });
          dispatch(
            setErrorCount_famplanchildcare_form(error.errorFields.length)
          );
        });
      tanfsuspensionbased_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "TANF Suspicion Based Drug Testing (Only those who meet suspicion-based indicators)":
              values,
          });
          dispatch(setErrorCount_tanfsuspensionbased_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "TANF Suspicion Based Drug Testing (Only those who meet suspicion-based indicators)":
              error.values,
          });
          dispatch(
            setErrorCount_tanfsuspensionbased_form(error.errorFields.length)
          );
        });
      dvsass_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "DOMESTIC VIOLENCE, SEXUAL ASSAULT, OR STALKING SCREENING (REQUIRED)":
              values,
          });
          dispatch(setErrorCount_dvsass_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "DOMESTIC VIOLENCE, SEXUAL ASSAULT, OR STALKING SCREENING (REQUIRED)":
              error.values,
          });
          dispatch(setErrorCount_dvsass_form(error.errorFields.length));
        });
      icebt_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            EBT: values,
          });
          dispatch(setErrorCount_icebt_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            EBT: error.values,
          });
          dispatch(setErrorCount_icebt_form(error.errorFields.length));
        });
      expeditedstatus_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "EXPEDITED STATUS": values,
          });
          dispatch(setErrorCount_expeditedstatus_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "EXPEDITED STATUS": error.values,
          });
          dispatch(
            setErrorCount_expeditedstatus_form(error.errorFields.length)
          );
        });
      icmawrs_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "MANDATORY ABAWD / E&T / WORK REGISTRANT SCRIPTS": values,
          });
          dispatch(setErrorCount_icmawrs_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "MANDATORY ABAWD / E&T / WORK REGISTRANT SCRIPTS": error.values,
          });
          dispatch(setErrorCount_icmawrs_form(error.errorFields.length));
        });
      verificationslist_form_ref.current
        .validateFields()
        .then((values) => {
          values["Due Date"] = moment(values["Due Date"]);
          interviewFormData.push({
            "VERIFICATIONS LIST": values,
          });
          dispatch(setErrorCount_verificationslist_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "VERIFICATIONS LIST": error.values,
          });
          dispatch(
            setErrorCount_verificationslist_form(error.errorFields.length)
          );
        });
      todo_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            TODO: values,
          });
          dispatch(setErrorCount_todo_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            TODO: error.values,
          });
          dispatch(setErrorCount_todo_form(error.errorFields.length));
        });
      runedbc_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "RUN EDBC": values,
          });
          dispatch(setErrorCount_runedbc_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "RUN EDBC": error.values,
          });
          dispatch(setErrorCount_runedbc_form(error.errorFields.length));
        });
      narrative_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            NARRATIVE: values,
          });
          dispatch(setErrorCount_narrative_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            NARRATIVE: error.values,
          });
          dispatch(setErrorCount_narrative_form(error.errorFields.length));
        });
      const c_date = new Date();
      let dateAndTimeSubmitted = moment(
        c_date,
        "MMMM Do YYYY, h:mm:ss a"
      ).format("LLL");

      let currentAgent = {
        contactId: contactId,
        "Last Update by": current_agent_name,
        "Date and Time": dateAndTimeSubmitted,
      };
      console.log("Last Update", getLastAgentUpdate);
      console.log("Last Update1", currentAgent);
      // console.log("Last Update", currentAgent);
      let lastUpdatedBy = [
        ...getLastAgentUpdate["Last Update Details"],
        currentAgent,
      ];

      console.log("Last Update5", lastUpdatedBy);
      // setLastAgentUpdate({ "Last Update Details": lastUpdatedBy });
      interviewFormData.push({
        "Last Update Details": lastUpdatedBy,
      });

      setInterviewData(interviewFormData);
    } catch (error) {
      console.log("Error during validation", error);
    }
  };

  const sendContactDetails = (
    file_name,
    contact_name,
    contact_number,
    items,
    is_autosave
  ) => {
    const c_date = new Date();
    let time_date_submitted = moment(c_date, "MMMM Do YYYY, h:mm:ss a").format(
      "LLL"
    );
    if (contact_name === undefined || contact_name === null) {
      contact_name = "";
    }
    if (contact_number === undefined || contact_number === null) {
      contact_number = "";
    }

    let contactDetails = {
      fileName: file_name,
      contactId: contactId,
      caseNumber: caseNumber,
      contactName: contact_name,
      contactPhoneNumber: contact_number,
      callAnswered: callAnswered,
      dateTimeSubmitted: time_date_submitted,
      formDetails: items,
      isAutosave: is_autosave,
      agentName: current_agent_name,
    };
    console.log("[sendContactDetails][1]", contactDetails);

    fetch(LAMBDAS.SAVE_CONTACT, {
      method: "POST",
      body: JSON.stringify(contactDetails),
    })
      .then((response) => response.json())
      .then((result) => {
        console.log("[sendContactDetails][Success]:", result.response);
        if (result.response === "SUCCESS") {
          console.log(
            "[sendContactDetails][Success][InsideIf]:",
            result.response
          );
          if (completed === "INCOMPLETE") {
            message.success("Form Submitted Successfully!");
            setAssessmentForm(false);
            // set_load_data(false);
            clearFields();
            // set_contact_exists(false);
            set_contact_loading(true);
          }
        } else {
          message.error("Failed to save. Please try again.");
          console.log("[sendContactDetails][error]");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        console.log("[sendContactDetails][error]", error);
      });
  };

  const clearFields = () => {
    // setContactID("");
    // setAgentID("");
    setCallAnswered("");

    // setContactName("");
    setCompleted("");
    // answer_call_form_ref.current.setFields([]);
    answer_call_form_ref.current.resetFields();
    right_resp_form_ref.current.resetFields();
    registration_form_ref.current.resetFields();
    tanfdt_form_ref.current.resetFields();
    tanfwpcoop_form_ref.current.resetFields();
    childcareonly_form_ref.current.resetFields();
    cctanf_form_ref.current.resetFields();
    screennamevr_form_ref.current.resetFields();
    screennamepw_form_ref.current.resetFields();
    csallprograms_form_ref.current.resetFields();
    csauthrep_form_ref.current.resetFields();
    cssummaryscreen_form_ref.current.resetFields();
    reportingpage_form_ref.current.resetFields();
    indemoscreen_form_ref.current.resetFields();
    citidentitylist_form_ref.current.resetFields();
    householdstatuslist_form_ref.current.resetFields();
    relationshiplist_form_ref.current.resetFields();
    pregnancylist_form_ref.current.resetFields();
    otherprogramlist_form_ref.current.resetFields();
    noncompliancelist_form_ref.current.resetFields();
    timelimitsummary_form_ref.current.resetFields();
    purchasepreparelist_form_ref.current.resetFields();
    schoolattlist_form_ref.current.resetFields();
    livingarrangement_form_ref.current.resetFields();
    noncustparentlist_form_ref.current.resetFields();
    medcondlist_form_ref.current.resetFields();
    emplistinclist_form_ref.current.resetFields();
    resourcelist_form_ref.current.resetFields();
    expenselist_form_ref.current.resetFields();
    dcexpenselist_form_ref.current.resetFields();
    mdexpenselist_form_ref.current.resetFields();
    mdcareexpenselist_form_ref.current.resetFields();
    childcareneedlist_form_ref.current.resetFields();
    pcscheduledlist_form_ref.current.resetFields();
    famplanchildcare_form_ref.current.resetFields();
    tanfsuspensionbased_form_ref.current.resetFields();
    dvsass_form_ref.current.resetFields();
    icebt_form_ref.current.resetFields();
    expeditedstatus_form_ref.current.resetFields();
    icmawrs_form_ref.current.resetFields();
    verificationslist_form_ref.current.resetFields();
    todo_form_ref.current.resetFields();
    runedbc_form_ref.current.resetFields();
    narrative_form_ref.current.resetFields();
    dispatch(setErrorCount_answer_call_form(0));
    dispatch(setErrorCount_right_resp_form(0));
    dispatch(setErrorCount_registration_form(0));
    dispatch(setErrorCount_tanfdt_form(0));
    dispatch(setErrorCount_cctanf_form(0));
    dispatch(setErrorCount_tanfwpcoop_form(0));
    dispatch(setErrorCount_childcareonly_form(0));
    dispatch(setErrorCount_screenvr_form(0));
    dispatch(setErrorCount_screenpw_form(0));
    dispatch(setErrorCount_csallprograms_form(0));
    dispatch(setErrorCount_csauthrep_form(0));
    dispatch(setErrorCount_cssummaryscreen_form(0));
    dispatch(setErrorCount_reportingpage_form(0));
    dispatch(setErrorCount_indemoscreen_form(0));
    dispatch(setErrorCount_citidentitylist_form(0));
    dispatch(setErrorCount_householdstatuslist_form(0));
    dispatch(setErrorCount_relationshiplist_form(0));
    dispatch(setErrorCount_pregnancylist_form(0));
    dispatch(setErrorCount_otherprogramlist_form(0));
    dispatch(setErrorCount_noncompliancelist_form(0));
    dispatch(setErrorCount_timelimitsummary_form(0));
    dispatch(setErrorCount_purchasepreparelist_form(0));
    dispatch(setErrorCount_schoolattlist_form(0));
    dispatch(setErrorCount_livingarrangement_form(0));
    dispatch(setErrorCount_noncustparentlist_form(0));
    dispatch(setErrorCount_medcondlist_form(0));
    dispatch(setErrorCount_emplistinclist_form(0));
    dispatch(setErrorCount_resourcelist_form(0));
    dispatch(setErrorCount_expenselist_form(0));
    dispatch(setErrorCount_dcexpenselist_form(0));
    dispatch(setErrorCount_mdexpenselist_form(0));
    dispatch(setErrorCount_mdcareexpenselist_form(0));
    dispatch(setErrorCount_childcareneedlist_form(0));
    dispatch(setErrorCount_pcscheduledlist_form(0));
    dispatch(setErrorCount_famplanchildcare_form(0));
    dispatch(setErrorCount_tanfsuspensionbased_form(0));
    dispatch(setErrorCount_dvsass_form(0));
    dispatch(setErrorCount_icebt_form(0));
    dispatch(setErrorCount_expeditedstatus_form(0));
    dispatch(setErrorCount_icmawrs_form(0));
    dispatch(setErrorCount_verificationslist_form(0));
    dispatch(setErrorCount_todo_form(0));
    dispatch(setErrorCount_runedbc_form(0));
    dispatch(setErrorCount_narrative_form(0));
    setAssessmentForm(false);
  };

  // const showDrawer = () => {
  //   // setOpen(true);
  //   set_load_data(false);
  //   clearFields();
  //   set_contact_exists(false);
  // };
  // const onClose = () => {
  //   // setOpen(false);
  //   // setMsg(false);
  // };
  let url_pdf = LAMBDAS.FORM_PDF + documentName;
  const { data, error } = useFormFetch(
    url_pdf,
    payLoad,
    "PUT",
    "application/pdf"
  );

  const populate_form = (datasourceList) => {
    console.log("[populate_form][1]", datasourceList);
    console.log("[populate_form][2]", datasourceList[8]["PROGRAM WITHDRAW"]);

    datasourceList.forEach((item) => {
      // console.log("[populate_form][3]", item[]);
      Object.keys(item).forEach((key) => {
        console.log("[populate_form][5]", item[key]);
        switch (key) {
          case "TANF/CC/FOOD ASSISTANCE PROGRAM":
            if (Object.keys(item).length > 0) {
              answer_call_form_ref.current.setFieldsValue(item[key]);
              answer_call_form_ref.current.setFieldValue({
                "Agent Name": current_agent_name,
              });
            } else {
              console.log(
                "[populate_form][TANF/CC/FOOD ASSISTANCE PROGRAM]",
                key
              );
            }
            break;
          case "RIGHTS AND RESPONSIBILITIES":
            if (Object.keys(item).length > 0) {
              right_resp_form_ref.current.setFieldsValue(item[key]);
            }
            break;
          case "REGISTRATION":
            if (Object.keys(item).length > 0) {
              registration_form_ref.current.setFieldsValue(item[key]);
            }
            break;
          case "TANF Drug Testing Program Requirements":
            if (Object.keys(item).length > 0) {
              if (
                item[key].hasOwnProperty("Date of Conviction") &&
                item[key]["Date of Conviction"] !== "" &&
                item[key]["Date of Conviction"] !== null
              ) {
                item[key]["Date of Conviction"] = moment(
                  item[key]["Date of Conviction"]
                );
              }
              tanfdt_form_ref.current.setFieldsValue(item[key]);
            }
            break;
          case "TANF ONLY and WORK PROGRAM COOP":
            if (Object.keys(item).length > 0) {
              tanfwpcoop_form_ref.current.setFieldsValue(item[key]);
            }
            break;
          case "CHILD CARE ONLY":
            if (Object.keys(item).length > 0) {
              childcareonly_form_ref.current.setFieldsValue(item[key]);
            }
            break;
          case "CC/TANF ONLY":
            if (Object.keys(item).length > 0) {
              cctanf_form_ref.current.setFieldsValue(item[key]);
            }
            break;
          case "VOTER REGISTRATION":
            if (Object.keys(item).length > 0) {
              screennamevr_form_ref.current.setFieldsValue(item[key]);
            }
            break;
          case "PROGRAM WITHDRAW":
            if (Object.keys(item).length > 0) {
              screennamepw_form_ref.current.setFieldsValue(item[key]);
            }
            break;
          case "CASE SUMMARY (All Programs)":
            if (Object.keys(item).length > 0 && typeof item[key] !== "object") {
              csallprograms_form_ref.current.setFieldsValue(item[key]);
            }
            break;
          case "AUTHORIZED REP":
            if (Object.keys(item).length > 0 && typeof item[key] !== "object") {
              csauthrep_form_ref.current.setFieldsValue(item[key]);
            }
            break;
          case "CONTACT SUMMARY SCREEN (All Programs)":
            if (Object.keys(item).length > 0) {
              cssummaryscreen_form_ref.current.setFieldsValue(item[key]);
            }
            break;
          case "REPORTING PAGE (Reviews/IR ONLY)":
            if (Object.keys(item).length > 0) {
              reportingpage_form_ref.current.setFieldsValue(item[key]);
            }
            break;
          case "INDIVIDUAL DEMOGRAPHICS SCREEN (All Programs)":
            if (Object.keys(item).length > 0) {
              indemoscreen_form_ref.current.setFieldsValue(item[key]);
            }
            break;
          case "CITIZENSHIP/ IDENTITY LIST (All Programs)":
            if (Object.keys(item).length > 0) {
              citidentitylist_form_ref.current.setFieldsValue(item[key]);
            }
            break;
          case "HOUSEHOLD STATUS LIST":
            if (Object.keys(item).length > 0) {
              householdstatuslist_form_ref.current.setFieldsValue(item[key]);
            }
            break;
          case "RELATIONSHIP LIST (All Programs)":
            if (Object.keys(item).length > 0) {
              relationshiplist_form_ref.current.setFieldsValue(item[key]);
            }
            break;
          case "PREGNANCY LIST (All Programs)":
            if (Object.keys(item).length > 0) {
              if (
                item[key].hasOwnProperty("Due Date") &&
                item[key]["Due Date"] !== "" &&
                item[key]["Due Date"] !== null
              ) {
                item[key]["Due Date"] = moment(item[key]["Due Date"]);
              }
              pregnancylist_form_ref.current.setFieldsValue(item[key]);
            }
            break;
          case "OTHER PROGRAM LIST (All Programs)":
            if (Object.keys(item).length > 0) {
              otherprogramlist_form_ref.current.setFieldsValue(item[key]);
            }
            break;
          case "NON-COMPLIANCE LIST (All Programs)":
            if (Object.keys(item).length > 0) {
              noncompliancelist_form_ref.current.setFieldsValue(item[key]);
            }
            break;
          case "TIME LIMIT SUMMARY (All Programs)":
            if (Object.keys(item).length > 0) {
              timelimitsummary_form_ref.current.setFieldsValue(item[key]);
            }
            break;
          case "PURCHASE AND PREPARE LIST (FA)":
            if (Object.keys(item).length > 0) {
              purchasepreparelist_form_ref.current.setFieldsValue(item[key]);
            }
            break;
          case "SCHOOL ATTENDANCE LIST (All Programs)":
            if (Object.keys(item).length > 0) {
              schoolattlist_form_ref.current.setFieldsValue(item[key]);
            }
            break;
          case "LIVING ARRANGEMENTS":
            if (Object.keys(item).length > 0) {
              livingarrangement_form_ref.current.setFieldsValue(item[key]);
            }
            break;
          case "NONCUSTODIAL PARENT LIST (All Programs)":
            if (Object.keys(item).length > 0) {
              noncustparentlist_form_ref.current.setFieldsValue(item[key]);
            }
            break;
          case "MEDICAL CONDITION LIST (FA, TANF)":
            if (Object.keys(item).length > 0) {
              medcondlist_form_ref.current.setFieldsValue(item[key]);
            }
            break;
          case "EMPLOYMENT LIST /INCOME LIST":
            if (Object.keys(item).length > 0) {
              emplistinclist_form_ref.current.setFieldsValue(item[key]);
            }
            break;
          case "RESOURCE LIST (All Programs)":
            if (Object.keys(item).length > 0) {
              resourcelist_form_ref.current.setFieldsValue(item[key]);
            }
            break;
          case "SHELTER - EXPENSE LIST (FA, TANF)":
            if (Object.keys(item).length > 0) {
              expenselist_form_ref.current.setFieldsValue(item[key]);
            }
            break;
          case "DEPENDENT CARE/ CSS - EXPENSE LIST (FA, TANF)":
            if (Object.keys(item).length > 0) {
              dcexpenselist_form_ref.current.setFieldsValue(item[key]);
            }
            break;
          case "MEDICAL - EXPENSE LIST (FA, TANF)":
            if (Object.keys(item).length > 0) {
              mdexpenselist_form_ref.current.setFieldsValue(item[key]);
            }
            break;
          case "MEDICARE EXPENSE LIST (FA Only)":
            if (Object.keys(item).length > 0) {
              mdcareexpenselist_form_ref.current.setFieldsValue(item[key]);
            }
            break;
          case "CHILD CARE NEED LIST – PARENT AND/ OR CHILD CARE NEED LIST – CHILD (CC Only)":
            if (Object.keys(item).length > 0) {
              childcareneedlist_form_ref.current.setFieldsValue(item[key]);
            }
            break;
          case "PARENT SCHEDULE LIST AND/ OR CHILD SCHEDULE LIST (CC Only)":
            if (Object.keys(item).length > 0) {
              pcscheduledlist_form_ref.current.setFieldsValue(item[key]);
            }
            break;
          case "FAMILY PLAN – CHILD CARE LIST (CC Only)":
            if (Object.keys(item).length > 0) {
              famplanchildcare_form_ref.current.setFieldsValue(item[key]);
            }
            break;
          case "TANF Suspicion Based Drug Testing (Only those who meet suspicion-based indicators)":
            if (Object.keys(item).length > 0) {
              tanfsuspensionbased_form_ref.current.setFieldsValue(item[key]);
            }
            break;
          case "DOMESTIC VIOLENCE, SEXUAL ASSAULT, OR STALKING SCREENING (REQUIRED)":
            if (Object.keys(item).length > 0) {
              dvsass_form_ref.current.setFieldsValue(item[key]);
            }
            break;
          case "EBT":
            if (Object.keys(item).length > 0) {
              icebt_form_ref.current.setFieldsValue(item[key]);
            }
            break;
          case "EXPEDITED STATUS":
            if (Object.keys(item).length > 0) {
              expeditedstatus_form_ref.current.setFieldsValue(item[key]);
            }
            break;
          case "MANDATORY ABAWD / E&T / WORK REGISTRANT SCRIPTS":
            if (Object.keys(item).length > 0) {
              icmawrs_form_ref.current.setFieldsValue(item[key]);
            }
            break;
          case "VERIFICATIONS LIST":
            if (Object.keys(item).length > 0) {
              if (
                item[key].hasOwnProperty("Due Date") &&
                item[key]["Due Date"] !== "" &&
                item[key]["Due Date"] !== null
              ) {
                item[key]["Due Date"] = moment(item[key]["Due Date"]);
              }
              verificationslist_form_ref.current.setFieldsValue(item[key]);
            }
            break;
          case "TODO":
            if (Object.keys(item).length > 0) {
              todo_form_ref.current.setFieldsValue(item[key]);
            }
            break;
          case "RUN EDBC":
            if (Object.keys(item).length > 0) {
              runedbc_form_ref.current.setFieldsValue(item[key]);
            }
            break;
          case "NARRATIVE":
            if (Object.keys(item).length > 0) {
              narrative_form_ref.current.setFieldsValue(item[key]);
            }
            break;
          default:
            console.log("[populate_form][default_case]");
            break;
        }
      });
    });

    // answer_call_form_ref.current.setFieldValue({
    //   "Agent Name": current_agent_name,
    // });
    // right_resp_form_ref.current.setFieldValue({
    //   "Worker Name": props.agentName,
    // });
    // narrative_form_ref.current.setFieldValue({
    //   "Worker Name:": props.agentName,
    // });

    set_collapse_active_keys([
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
    ]);
    // set_contact_loading(false);
    // set_load_data(true);
  };

  const addZero = (i) => {
    if (i < 10) {
      i = "0" + i;
    }
    return i;
  };

  const sendData = () => {
    switch ((data === null, error === null)) {
      case (false, true):
        console.log("[sendData][false-true]");
        // set_load_data(false);
        clearFields();
        // set_contact_exists(false);
        // set_contact_loading(true);

        deleteTempFile();
        setSuccess(true);

        break;
      case (true, false):
        console.log("INSIDE TRUE FALSE");

        break;
      default:
        break;
    }
  };

  const deleteTempFile = () => {
    console.log("[CONTACTID][deleteTempFile]", contactId);
    let contact_details = {
      contactId: contactId,
    };
    fetch(LAMBDAS.REMOVE_CONTACT, {
      method: "POST",
      body: JSON.stringify(contact_details),
    })
      .then((response) => response.json())
      .then((result) => {
        console.log("[deleteTempFile][Success]:", result.response);
        if (result.response === "SUCCESS") {
          console.log("[deleteTempFile][Success][InsideIf]:", result.response);
          if (completed === "INCOMPLETE") {
            message.success("Successful Update!");
          }
        } else {
          console.log("[deleteTempFile][error]");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        console.log("[deleteTempFile][error]", error);
      });
  };

  const generate_pdf = (display_data) => {
    let clientName = "";
    // let contactId = "cccxedrffsefsd1";
    // let contactId = currentFileID;
    const PDF_WIDTH = 816;
    const PDF_HEIGHT = PDF_WIDTH * 1.2941;
    const doc = new jsPDF("p", "pt"[(PDF_WIDTH, PDF_HEIGHT)]);
    const margin = { top: 20, left: 15, right: 15, bottom: 10 };

    doc.addImage(dcf_logo, "PNG", 170, 5, 30, 20);
    let yPosition = margin.top + 15;
    const bottomMargin = margin.bottom;
    const pageHeight = doc.internal.pageSize.height;
    const pageWidth = doc.internal.pageSize.width;
    const textWidth = pageWidth - margin.left - margin.right;

    display_data.forEach((element) => {
      let [dataKey, dataValue] = Object.entries(element)[0];
      doc.setFontSize(10);
      doc.text(`${dataKey}`, margin.left, yPosition);
      yPosition += 5;

      Object.entries(dataValue).forEach(([key, value]) => {
        if (key === "Client Name") {
          clientName = value;
        }
        if (dataKey === "Last Update Details") {
          let newValue = "";
          for (let key in value) {
            newValue += key + ": " + value[key] + "\t";
          }
          value = newValue.trim();
        }

        if (yPosition + 10 > pageHeight - bottomMargin) {
          doc.addPage();
          yPosition = margin.top;
        }
        const wrappedText = doc.splitTextToSize(`${key}:${value}`, textWidth);
        wrappedText.forEach((line) => {
          doc.setFontSize(8);
          doc.text(line, margin.left + 5, yPosition);
          yPosition += 5;
        });
        // doc.text(`${key}:${value}`, 20, yPosition);
        // yPosition += 5;
      });
      // yPosition += 2;

      if (yPosition + 10 > pageHeight - bottomMargin) {
        doc.addPage();
        yPosition = margin.top;
      }
    });
    // const cDate = new Date();
    // let currentDate = cDate.toDateString().split(" ").splice(1, 3).join("_");
    // let currentTime = new Date();
    // let docName =
    //   contactId +
    //   "_" +
    //   currentDate +
    //   "_" +
    //   addZero(currentTime.getHours()) +
    //   addZero(currentTime.getMinutes()) +
    //   addZero(currentTime.getSeconds()) +
    //   ".pdf";
    const cDate = new Date();
    let dateNTimestampFormat =
      cDate.getFullYear() +
      "-" +
      String(cDate.getMonth() + 1).padStart(2, 0) +
      "-" +
      String(cDate.getDate()).padStart(2, 0) +
      "_" +
      Math.floor(cDate.getTime() / 1000);
    let file_name =
      "KEES Case^Journaling^" +
      caseNumber +
      "^" +
      clientName +
      "^" +
      dateNTimestampFormat;
    setDocumentName(file_name);

    let blob = doc.output("blob");
    let formData = new FormData();
    formData.append("file", blob, file_name);
    // doc.save(file_name); //for downloading the file
    return formData;
  };

  const submit_forms = () => {
    // let pdf_data = [];
    let prep_datasource = [];
    let client_name = "";
    let callback_number = "";
    for (const item of LIST_FORMS) {
      for (let key0 in interview_data) {
        for (let key1 in interview_data[key0]) {
          for (let temp_key in interview_data[key0][key1]) {
            if (temp_key === "Client Name") {
              client_name = interview_data[key0][key1][temp_key];
            }
            if (temp_key === "Callback Number") {
              callback_number = interview_data[key0][key1][temp_key];
            }

            if (interview_data[key0][key1][temp_key] === undefined)
              interview_data[key0][key1][temp_key] = "";
          }
          if (item === key1) {
            prep_datasource.push(interview_data[key0]);
          }
        }
      }
    }
    console.log("[submit_form][agentName]", current_agent_name);
    // console.log(
    //   "[submit_form][agentName][2]",
    //   current_agent_name.replace(/ /g, "")
    // );
    const cDate = new Date();
    let dateNTimestampFormat =
      cDate.getFullYear() +
      "-" +
      String(cDate.getMonth() + 1).padStart(2, 0) +
      "-" +
      String(cDate.getDate()).padStart(2, 0) +
      "_" +
      Math.floor(cDate.getTime() / 1000);
    let file_name =
      "KEES Case^Journaling^" +
      caseNumber +
      "^" +
      client_name +
      "^" +
      dateNTimestampFormat;

    // let file_name = currentFileID + "_" + current_agent_name.replace(/ /g, "");
    if (completed !== "COMPLETED") {
      console.log("[TEMP DATA]");
      let isAutosave = false;
      sendContactDetails(
        file_name,
        client_name,
        callback_number,
        prep_datasource,
        isAutosave
      );
    } else {
      // let total_err = parseInt(
      //   answer_call_form_error_count.errorCount +
      //     right_resp_form_error_count.errorCount +
      //     registration_form_error_count.errorCount +
      //     tanfdt_form_error_count.errorCount +
      //     tanfwpcoop_form_error_count.errorCount +
      //     childcareonly_form_error_count.errorCount +
      //     cctanf_form_error_count.errorCount +
      //     screenvr_form_error_count.errorCount +
      //     screenpw_form_error_count.errorCount +
      //     csallprograms_form_error_count.errorCount +
      //     csauthrep_form_error_count.errorCount +
      //     cssummaryscreen_form_error_count.errorCount +
      //     reportingpage_form_error_count.errorCount +
      //     indemoscreen_form_error_count.errorCount +
      //     citidentitylist_form_error_count.errorCount +
      //     householdstatuslist_form_error_count.errorCount +
      //     relationshiplist_form_error_count.errorCount +
      //     pregnancylist_form_error_count.errorCount +
      //     otherprogramlist_form_error_count.errorCount +
      //     noncompliancelist_form_error_count.errorCount +
      //     timelimitsummary_form_error_count.errorCount +
      //     purchasepreparelist_form_error_count.errorCount +
      //     schoolattlist_form_error_count.errorCount +
      //     livingarrangement_form_error_count.errorCount +
      //     noncustparentlist_form_error_count.errorCount +
      //     medcondlist_form_error_count.errorCount +
      //     emplistinclist_form_error_count.errorCount +
      //     resourcelist_form_error_count.errorCount +
      //     expenselist_form_error_count.errorCount +
      //     dcexpenselist_form_error_count.errorCount +
      //     mdexpenselist_form_error_count.errorCount +
      //     mdcareexpenselist_form_error_count.errorCount +
      //     childcareneedlist_form_error_count.errorCount +
      //     pcscheduledlist_form_error_count.errorCount +
      //     famplanchildcare_form_error_count.errorCount +
      //     tanfsuspensionbased_form_error_count.errorCount +
      //     dvsass_form_error_count.errorCount +
      //     icebt_form_error_count.errorCount +
      //     expeditedstatus_form_error_count.errorCount +
      //     icmawrs_form_error_count.errorCount +
      //     verificationslist_form_error_count.errorCount +
      //     todo_form_error_count.errorCount +
      //     runedbc_form_error_count.errorCount +
      //     narrative_form_error_count.errorCount
      // );
      // if (total_err === 0) {
      let pdf_form = generate_pdf(prep_datasource);
      sendFormData(pdf_form);
      sendData();
      // }
    }
  };

  const cancel = (e) => {
    console.log(e);
  };
  // const onSelect = (selectedKeys, info) => {
  //   console.log("selected", selectedKeys, info);
  // };
  const sendFormData = (form_data) => {
    //replace with any final validation checks if needed
    if (true) {
      setpayLoad(form_data);
    }
  };

  const radioChange = (e) => {
    console.log(`radio to ${e.target.value}`);
    setCompleted(e.target.value);
  };

  const onChange = (key) => {
    console.log(`Collapsible: ${key}`);
    if (Object.keys(key).length !== 0) {
      set_collapse_active_keys([
        `${key[Object.keys(key)[Object.keys(key).length - 1]]}`,
      ]);
    } else {
      set_collapse_active_keys([]);
    }
  };

  // const onValuesChange_temp_data_form = (formData) => {
  //   console.log(
  //     "[onValuesChange_temp_data_form]",
  //     temp_data_form_ref.current.getFieldsValue()
  //   );
  // };

  // const onReset_temp_data_form = (data) => {
  //   console.log(
  //     "[onReset_temp_data_form]",
  //     temp_data_form_ref.current.getFieldsValue()
  //   );
  //   temp_data_form_ref.current.resetFields();
  // };

  return (
    <div
      style={{
        // height: props.form_height,
        overflow: "auto",
        backgroundColor: "#ffffff",
        // backgroundColor: "#E5E4E2",
        borderRadius: 5,
        // padding: "5px",
      }}
    >
      <div>
        {isSuccess ? (
          <Result
            status="success"
            title="Successfully Submitted the Form"
            // subTitle={"Filename: " + fileName}
            subTitle={
              "Filename: " + documentName
              // currentFileID +
              // "_" +
              // current_agent_name.replace(/ /g, "")
            }
          />
        ) : (
          <Spin tip="Loading..." spinning={is_contact_loading}>
            <ConfigProvider
              theme={{
                token: {
                  colorText: "#FFFFFF",
                  // fontSize: props.font_size,
                  colorBorder: "#FFFFFF",
                },
                components: {
                  Collapse: {
                    contentBg: "#818589",
                  },
                  Select: {
                    selectorBg: "#818589",
                    optionSelectedBg: "#818589",
                    colorBgElevated: "#818589",
                    activeBorderColor: "#FFFFFF",
                  },
                  Input: {
                    colorText: "#000000",
                  },
                  DatePicker: {
                    colorText: "#000000",
                  },
                  Radio: {
                    dotSize: 8,
                    radioSize: 16,
                    fontSize: 12,
                  },
                  Badge: {
                    dotSize: 8,
                    textFontSize: 12,
                    indicatorHeight: 20,
                    indicatorZIndex: 20,
                  },
                },
              }}
            >
              <Collapse
                defaultActiveKey={["1"]}
                activeKey={collapse_active_keys}
                onChange={onChange}
              >
                <Panel
                  style={{
                    backgroundColor: "#122249",
                    // contentBg: "#122249",
                  }}
                  header={
                    <div>
                      TANF/CC/FOOD ASSISTANCE PROGRAM{" "}
                      <Badge
                        style={{ marginLeft: 50 }}
                        showZero={false}
                        count={answer_call_form_error_count.errorCount}
                      />
                    </div>
                  }
                  key="1"
                >
                  <AnswerCall
                    callAnswered={callAnswered}
                    agentName={current_agent_name}
                    // agentName={agentName}
                    // callbackNumber={props.customerNumber}
                    // onFinish={onFinish_answerCall}
                    // form={answer_call_form}
                    ref={answer_call_form_ref}
                    onValuesChange={onValuesChange_answer_call_form}
                  />
                </Panel>

                <Panel
                  header={
                    <div>
                      RIGHTS AND RESPONSIBILITIES
                      <Badge
                        style={{ marginLeft: 50 }}
                        showZero={false}
                        count={right_resp_form_error_count.errorCount}
                      />
                    </div>
                  }
                  key="2"
                  style={{ backgroundColor: "#e8ac3c" }}
                >
                  <RightsAndResponsibilities
                    agentName={current_agent_name}
                    // onFinish={onFinish_rightAndResp}
                    // form={right_resp_form}
                    ref={right_resp_form_ref}
                    onValuesChange={onValuesChange_right_resp_form}
                  />
                </Panel>
                <Panel
                  header={
                    <div>
                      REGISTRATION
                      <Badge
                        style={{ marginLeft: 50 }}
                        showZero={false}
                        count={registration_form_error_count.errorCount}
                      />
                    </div>
                  }
                  key="3"
                  style={{ backgroundColor: "#787373" }}
                >
                  <Registration
                    // queue={props.queue}
                    // caseNumber={props.caseNumber}
                    ref={registration_form_ref}
                    onValuesChange={onValuesChange_registration_form}
                  />
                </Panel>
                <Panel
                  header={
                    <div>
                      SCREENING
                      <Badge
                        style={{ marginLeft: 50 }}
                        showZero={false}
                        count={
                          tanfdt_form_error_count.errorCount +
                          tanfwpcoop_form_error_count.errorCount +
                          childcareonly_form_error_count.errorCount +
                          cctanf_form_error_count.errorCount
                        }
                      />
                    </div>
                  }
                  key="4"
                  style={{ backgroundColor: "#122249" }}
                >
                  <Row style={{ fontWeight: "bold" }}>
                    TANF Drug Testing Program Requirements
                  </Row>
                  <Row>
                    <TANFDT
                      // felonyAnswer={props.felonyAnswer}
                      ref={tanfdt_form_ref}
                      onValuesChange={onValuesChange_tanfdt_form}
                      // onFinish={onFinish_tanfdt}
                      // form={tanfdt_form}
                    />
                  </Row>

                  <Row style={{ fontWeight: "bold" }}>
                    TANF ONLY and WORK PROGRAM COOP
                  </Row>
                  <Row>
                    <TANFWPCOOP
                      ref={tanfwpcoop_form_ref}
                      onValuesChange={onValuesChange_tanfwpcoop_form}
                      // onFinish={onFinish_tanfwpcoop}
                      // form={tanfwpcoop_form}
                    />
                  </Row>
                  <Row style={{ fontWeight: "bold" }}>CHILD CARE ONLY</Row>
                  <Row>
                    <CHILDCAREONLY
                      ref={childcareonly_form_ref}
                      onValuesChange={onValuesChange_childcareonly_form}
                      // onFinish={onFinish_childcareonly}
                      // form={childcareonly_form}
                    />
                  </Row>
                  <Row style={{ fontWeight: "bold" }}>CC/TANF ONLY</Row>
                  <Row>
                    <CC_TANF
                      ref={cctanf_form_ref}
                      onValuesChange={onValuesChange_cctanf_form}
                      // onFinish={onFinish_cctanf}
                      // form={cctanf_form}
                    />
                  </Row>
                </Panel>
                <Panel
                  header={
                    <div>
                      SYSTEM ENTRY
                      <Badge
                        style={{ marginLeft: 50 }}
                        showZero={false}
                        count={
                          screenvr_form_error_count.errorCount +
                          screenpw_form_error_count.errorCount
                        }
                      />
                    </div>
                  }
                  key="5"
                  style={{ backgroundColor: "#e8ac3c" }}
                >
                  <Row style={{ marginTop: "10px" }}>
                    <ScreenNameVR
                      ref={screennamevr_form_ref}
                      onValuesChange={onValuesChange_screennamevr_form}
                      // onFinish={onFinish_screennamevr}
                      // form={screennamevr_form}
                    />
                  </Row>
                  <Row style={{ fontWeight: "bold" }}>
                    Screen Name: PROGRAM WITHDRAW
                  </Row>
                  <Row style={{ marginTop: "10px" }}>
                    <ScreenNamePW
                      ref={screennamepw_form_ref}
                      onValuesChange={onValuesChange_screennamepw_form}
                      // onFinish={onFinish_screennamepw}
                      // form={screennamepw_form}
                    />
                  </Row>
                </Panel>
                <Panel
                  header={
                    <div>
                      CASE SUMMARY
                      <Badge
                        style={{ marginLeft: 50 }}
                        showZero={false}
                        count={
                          csallprograms_form_error_count.errorCount +
                          csauthrep_form_error_count.errorCount
                        }
                      />
                    </div>
                  }
                  key="6"
                  style={{ backgroundColor: "#8b8f86" }}
                >
                  <Row style={{ marginTop: "10px" }}>
                    <CS_ALL_PROGRAMS
                      ref={csallprograms_form_ref}
                      onValuesChange={onValuesChange_csallprograms_form}
                      // onFinish={onFinish_csallprograms}
                      // form={csallprograms_form}
                    />
                  </Row>
                  <Row style={{ marginTop: "10px" }}>
                    <CS_AUTHREP
                      ref={csauthrep_form_ref}
                      onValuesChange={onValuesChange_csauthrep_form}
                      // onFinish={onFinish_csauthrep}
                      // form={csauthrep_form}
                    />
                  </Row>
                </Panel>
                <Panel
                  header={
                    <div>
                      CUSTOMER INFORMATION (Local Tab) Non- Financial
                      <Badge
                        style={{ marginLeft: 50 }}
                        showZero={false}
                        count={
                          cssummaryscreen_form_error_count.errorCount +
                          reportingpage_form_error_count.errorCount +
                          indemoscreen_form_error_count.errorCount +
                          citidentitylist_form_error_count.errorCount +
                          householdstatuslist_form_error_count.errorCount +
                          relationshiplist_form_error_count.errorCount +
                          pregnancylist_form_error_count.errorCount +
                          otherprogramlist_form_error_count.errorCount +
                          noncompliancelist_form_error_count.errorCount +
                          timelimitsummary_form_error_count.errorCount +
                          purchasepreparelist_form_error_count.errorCount +
                          schoolattlist_form_error_count.errorCount +
                          livingarrangement_form_error_count.errorCount +
                          noncustparentlist_form_error_count.errorCount +
                          medcondlist_form_error_count.errorCount
                        }
                      />
                    </div>
                  }
                  key="7"
                  style={{ backgroundColor: "#122249" }}
                >
                  <Row style={{ marginTop: "10px" }}>
                    <CS_SUMMARY_SCREEN
                      ref={cssummaryscreen_form_ref}
                      onValuesChange={onValuesChange_cssummaryscreen_form}
                      // onFinish={onFinish_cssummaryscreen}
                      // form={cssummaryscreen_form}
                    />
                  </Row>
                  <Row style={{ fontWeight: "bold" }}>
                    Screen Name: REPORTING PAGE (Reviews/IR ONLY)
                  </Row>
                  <Row style={{ marginTop: "10px" }}>
                    <ReportingPage
                      ref={reportingpage_form_ref}
                      onValuesChange={onValuesChange_cssummaryscreen_form}
                      // onFinish={onFinish_reportingpage}
                      // form={reportingpage_form}
                    />
                  </Row>
                  <Row style={{ marginTop: "10px" }}>
                    <INDEMOSCREEN
                      ref={indemoscreen_form_ref}
                      onValuesChange={onValuesChange_cssummaryscreen_form}
                      // onFinish={onFinish_indemoscreen}
                      // form={indemoscreen_form}
                    />
                  </Row>
                  <Row style={{ marginTop: "10px" }}>
                    <CITIDENTITYLIST
                      ref={citidentitylist_form_ref}
                      onValuesChange={onValuesChange_cssummaryscreen_form}
                      // onFinish={onFinish_citidentitylist}
                      // form={citidentitylist_form}
                    />
                  </Row>

                  <Row style={{ marginTop: "10px" }}>
                    <HOUSEHOLDSTATUSLIST
                      ref={householdstatuslist_form_ref}
                      onValuesChange={onValuesChange_cssummaryscreen_form}
                      // onFinish={onFinish_householdstatuslist}
                      // form={householdstatuslist_form}
                    />
                  </Row>

                  <Row style={{ marginTop: "10px" }}>
                    <RELATIONSHIPLIST
                      ref={relationshiplist_form_ref}
                      onValuesChange={onValuesChange_cssummaryscreen_form}
                      // onFinish={onFinish_relationshiplist}
                      // form={relationshiplist_form}
                    />
                  </Row>

                  <Row style={{ marginTop: "10px" }}>
                    <PREGNANCYLIST
                      ref={pregnancylist_form_ref}
                      onValuesChange={onValuesChange_cssummaryscreen_form}
                      // onFinish={onFinish_pregnancylist}
                      // form={pregnancylist_form}
                    />
                  </Row>
                  <Row style={{ marginTop: "10px" }}>
                    <OTHERPROGRAMLIST
                      ref={otherprogramlist_form_ref}
                      onValuesChange={onValuesChange_cssummaryscreen_form}
                      // onFinish={onFinish_otherprogramlist}
                      // form={otherprogramlist_form}
                    />
                  </Row>

                  <Row style={{ marginTop: "10px" }}>
                    <NONCOMPLIANCELIST
                      ref={noncompliancelist_form_ref}
                      onValuesChange={onValuesChange_cssummaryscreen_form}
                      // onFinish={onFinish_noncompliancelist}
                      // form={noncompliancelist_form}
                    />
                  </Row>

                  <Row style={{ marginTop: "10px" }}>
                    <TIMELIMITSUMMARY
                      ref={timelimitsummary_form_ref}
                      onValuesChange={onValuesChange_cssummaryscreen_form}
                      // onFinish={onFinish_timelimitsummary}
                      // form={timelimitsummary_form}
                    />
                  </Row>

                  <Row style={{ marginTop: "10px" }}>
                    <PURCHASEPREPARELIST
                      ref={purchasepreparelist_form_ref}
                      onValuesChange={onValuesChange_cssummaryscreen_form}
                      // onFinish={onFinish_purchasepreparelist}
                      // form={purchasepreparelist_form}
                    />
                  </Row>

                  <Row style={{ marginTop: "10px" }}>
                    <SCHOOLATTLIST
                      ref={schoolattlist_form_ref}
                      onValuesChange={onValuesChange_cssummaryscreen_form}
                      // onFinish={onFinish_schoolattlist}
                      // form={schoolattlist_form}
                    />
                  </Row>

                  <Row style={{ marginTop: "10px" }}>
                    <LIVINGARRANGEMENT
                      ref={livingarrangement_form_ref}
                      onValuesChange={onValuesChange_cssummaryscreen_form}
                      // onFinish={onFinish_livingarrangement}
                      // form={livingarrangement_form}
                    />
                  </Row>

                  <Row style={{ marginTop: "10px" }}>
                    <NONCUSTPARENTLIST
                      ref={noncustparentlist_form_ref}
                      onValuesChange={onValuesChange_cssummaryscreen_form}
                      // onFinish={onFinish_noncustparentlist}
                      // form={noncustparentlist_form}
                    />
                  </Row>

                  <Row style={{ marginTop: "10px" }}>
                    <MEDCONDLIST
                      ref={medcondlist_form_ref}
                      onValuesChange={onValuesChange_cssummaryscreen_form}
                      // onFinish={onFinish_medcondlist}
                      // form={medcondlist_form}
                    />
                  </Row>
                </Panel>
                <Panel
                  header={
                    <div>
                      CUSTOMER INFORMATION LOCAL TAB - FINANCIAL
                      <Badge
                        style={{ marginLeft: 50 }}
                        showZero={false}
                        count={
                          emplistinclist_form_error_count.errorCount +
                          resourcelist_form_error_count.errorCount
                        }
                      />
                    </div>
                  }
                  key="8"
                  style={{ backgroundColor: "#e8ac3c" }}
                >
                  <Row style={{ marginTop: "10px" }}>
                    <EMPLISTINCLIST
                      ref={emplistinclist_form_ref}
                      onValuesChange={onValuesChange_emplistinclist_form}
                      // onFinish={onFinish_emplistinclist}
                      // form={emplistinclist_form}
                    />
                  </Row>

                  <Row style={{ marginTop: "10px" }}>
                    <RESOURCELIST
                      ref={resourcelist_form_ref}
                      onValuesChange={onValuesChange_emplistinclist_form}
                      // onFinish={onFinish_resourcelist}
                      // form={resourcelist_form}
                    />
                  </Row>
                </Panel>
                <Panel
                  header={
                    <div>
                      SHELTER
                      <Badge
                        style={{ marginLeft: 50 }}
                        showZero={false}
                        count={expenselist_form_error_count.errorCount}
                      />
                    </div>
                  }
                  key="9"
                  style={{ backgroundColor: "#8b8f86" }}
                >
                  <Row style={{ marginTop: "10px" }}>
                    <EXPENSELIST
                      ref={expenselist_form_ref}
                      onValuesChange={onValuesChange_expenselist_form}
                      // onFinish={onFinish_expenselist}
                      // form={expenselist_form}
                    />
                  </Row>
                </Panel>
                <Panel
                  header={
                    <div>
                      DEPENDENT CARE/ CSS
                      <Badge
                        style={{ marginLeft: 50 }}
                        showZero={false}
                        count={dcexpenselist_form_error_count.errorCount}
                      />
                    </div>
                  }
                  key="10"
                  style={{ backgroundColor: "#122249" }}
                >
                  <Row>
                    <Col span={4}>Screen Name: </Col>
                    <Col style={{ fontWeight: "bold" }}>
                      EXPENSE LIST (FA, TANF)
                    </Col>
                  </Row>
                  <Row style={{ marginTop: "10px" }}>
                    <DCEXPENSELIST
                      ref={dcexpenselist_form_ref}
                      onValuesChange={onValuesChange_dcexpenselist_form}
                      // onFinish={onFinish_dcexpenselist}
                      // form={dcexpenselist_form}
                    />
                  </Row>
                </Panel>
                <Panel
                  header={
                    <div>
                      MEDICAL
                      <Badge
                        style={{ marginLeft: 50 }}
                        showZero={false}
                        count={
                          mdexpenselist_form_error_count.errorCount +
                          mdcareexpenselist_form_error_count.errorCount
                        }
                      />
                    </div>
                  }
                  key="11"
                  style={{ backgroundColor: "#e8ac3c" }}
                >
                  <Row>
                    <Col span={4}>Screen Name: </Col>
                    <Col style={{ fontWeight: "bold" }}>
                      EXPENSE LIST (FA, TANF)
                    </Col>
                  </Row>
                  <Row style={{ marginTop: "10px" }}>
                    <MDEXPENSELIST
                      ref={mdexpenselist_form_ref}
                      onValuesChange={onValuesChange_mdexpenselist_form}
                      // onFinish={onFinish_mdexpenselist}
                      // form={mdexpenselist_form}
                    />
                  </Row>

                  <Row style={{ marginTop: "10px" }}>
                    <MDCAREEXPENSELIST
                      ref={mdcareexpenselist_form_ref}
                      onValuesChange={onValuesChange_mdexpenselist_form}
                      // onFinish={onFinish_mdcareexpenselist}
                      // form={mdcareexpenselist_form}
                    />
                  </Row>
                </Panel>
                <Panel
                  header={
                    <div>
                      CUSTOMER INFORMATION – CHILD CARE
                      <Badge
                        style={{ marginLeft: 50 }}
                        showZero={false}
                        count={
                          childcareneedlist_form_error_count.errorCount +
                          pcscheduledlist_form_error_count.errorCount +
                          famplanchildcare_form_error_count.errorCount +
                          tanfsuspensionbased_form_error_count.errorCount +
                          dvsass_form_error_count.errorCount
                        }
                      />
                    </div>
                  }
                  key="12"
                  style={{ backgroundColor: "#8b8f86" }}
                >
                  <Row style={{ marginTop: "10px" }}>
                    <CHILDCARENEEDLIST
                      ref={childcareneedlist_form_ref}
                      onValuesChange={onValuesChange_childcareneedlist_form}
                      // onFinish={onFinish_childcareneedlist}
                      // form={childcareneedlist_form}
                    />
                  </Row>

                  <Row style={{ marginTop: "10px" }}>
                    <PCSCHEDULEDLIST
                      ref={pcscheduledlist_form_ref}
                      onValuesChange={onValuesChange_childcareneedlist_form}
                      // onFinish={onFinish_pcscheduledlist}
                      // form={pcscheduledlist_form}
                    />
                  </Row>

                  <Row style={{ marginTop: "10px" }}>
                    <FAMPLANCHILDCARE
                      ref={famplanchildcare_form_ref}
                      onValuesChange={onValuesChange_childcareneedlist_form}
                      // onFinish={onFinish_famplanchildcare}
                      // form={famplanchildcare_form}
                    />
                  </Row>
                  <Row>
                    <Col span={4}>Screen Name: </Col>
                    <Col style={{ fontWeight: "bold" }}>
                      TANF Suspicion Based Drug Testing (Only those who meet
                      suspicion-based indicators)
                    </Col>
                  </Row>
                  <Row style={{ marginTop: "10px" }}>
                    <TANFSUSPENSIONBASED
                      ref={tanfsuspensionbased_form_ref}
                      onValuesChange={onValuesChange_childcareneedlist_form}
                      // onFinish={onFinish_tanfsuspensionbased}
                      // form={tanfsuspensionbased_form}
                    />
                  </Row>

                  <Row style={{ marginTop: "10px" }}>
                    <DVSASS
                      ref={dvsass_form_ref}
                      onValuesChange={onValuesChange_childcareneedlist_form}
                      // onFinish={onFinish_dvsass}
                      // form={dvsass_form}
                    />
                  </Row>
                </Panel>
                <Panel
                  header={
                    <div>
                      INFORMING CLIENTS
                      <Badge
                        style={{ marginLeft: 50 }}
                        showZero={false}
                        count={
                          icebt_form_error_count.errorCount +
                          expeditedstatus_form_error_count.errorCount +
                          icmawrs_form_error_count.errorCount +
                          verificationslist_form_error_count.errorCount +
                          todo_form_error_count.errorCount +
                          runedbc_form_error_count.errorCount
                        }
                      />
                    </div>
                  }
                  key="13"
                  style={{ backgroundColor: "#122249" }}
                >
                  <Row>
                    <Col style={{ fontWeight: "bold" }}>Screen Name: EBT</Col>
                  </Row>
                  <Row style={{ marginTop: "10px" }}>
                    <ICEBT
                      ref={icebt_form_ref}
                      onValuesChange={onValuesChange_icebt_form}
                      // onFinish={onFinish_icebt}
                      // form={icebt_form}
                    />
                  </Row>
                  <Row>
                    <Col style={{ fontWeight: "bold" }}>
                      Screen Name: EXPEDITED STATUS
                    </Col>
                  </Row>
                  <Row style={{ marginTop: "10px" }}>
                    <EXPEDITEDSTATUS
                      ref={expeditedstatus_form_ref}
                      onValuesChange={onValuesChange_icebt_form}
                      // onFinish={onFinish_expeditedstatus}
                      // form={expeditedstatus_form}
                    />
                  </Row>
                  <Row style={{ marginTop: "10px" }}>
                    <Col style={{ fontWeight: "bold" }}>
                      Screen Name: MANDATORY ABAWD / E&T / WORK REGISTRANT
                      SCRIPTS
                    </Col>
                  </Row>
                  <Row style={{ marginTop: "10px" }}>
                    <ICMAWRS
                      ref={icmawrs_form_ref}
                      onValuesChange={onValuesChange_icebt_form}
                      // onFinish={onFinish_icmawrs}
                      // form={icmawrs_form}
                    />
                  </Row>
                  <Row style={{ marginTop: "10px", fontWeight: "bold" }}>
                    VERIFICATIONS LIST
                  </Row>
                  <Row style={{ marginTop: "10px" }}>
                    <VERIFICATIONSLIST
                      ref={verificationslist_form_ref}
                      onValuesChange={onValuesChange_icebt_form}
                      // onFinish={onFinish_verificationslist}
                      // form={verificationslist_form}
                    />
                  </Row>
                  <Row style={{ marginTop: "10px", fontWeight: "bold" }}>
                    TO DO
                  </Row>
                  <Row style={{ marginTop: "10px" }}>
                    <TODO
                      ref={todo_form_ref}
                      onValuesChange={onValuesChange_icebt_form}
                      // onFinish={onFinish_todo}
                      // form={todo_form}
                    />
                  </Row>
                  <Row style={{ marginTop: "10px", fontWeight: "bold" }}>
                    RUN EDBC
                  </Row>
                  <Row style={{ marginTop: "10px" }}>
                    <RUNEDBC
                      ref={runedbc_form_ref}
                      onValuesChange={onValuesChange_icebt_form}
                      // onFinish={onFinish_runedbc}
                      // form={runedbc_form}
                    />
                  </Row>
                </Panel>
                <Panel
                  header={
                    <div>
                      NARRATIVE
                      <Badge
                        style={{ marginLeft: 50 }}
                        showZero={false}
                        count={narrative_form_error_count.errorCount}
                      />
                    </div>
                  }
                  key="14"
                  style={{ backgroundColor: "#e8ac3c" }}
                >
                  <Row style={{ marginTop: "10px" }}>
                    <NARRATIVE
                      ref={narrative_form_ref}
                      onValuesChange={onValuesChange_narrative_form}
                      agentName={current_agent_name}
                      // onFinish={onFinish_narrative}
                      // form={narrative_form}
                    />
                  </Row>
                </Panel>
              </Collapse>
            </ConfigProvider>

            <Row style={{ marginTop: 15 }}>
              <Col span={4}>
                <label>Form Status:</label>
              </Col>
              <Col span={12}>
                <Radio.Group
                  // defaultValue="COMPLETED"
                  // buttonStyle="solid"
                  style={{ width: "100%" }}
                  onChange={radioChange}
                  value={completed}
                >
                  <Radio value="COMPLETED">COMPLETED</Radio>
                  <Radio value="INCOMPLETE">FOR UPDATE</Radio>
                </Radio.Group>
              </Col>
            </Row>
            {assessmentForm ? (
              <Alert
                message="Please complete the form/s."
                banner
                closable
                showIcon
                type="error"
                style={{ marginBottom: "15px" }}
              />
            ) : (
              ""
            )}
            {completed !== "" ? (
              <Row gutter={2} style={{ margin: 15 }}>
                <Col span={12}>
                  <Popconfirm
                    title="Click Yes to submit."
                    description="Are you sure the details provided are final?"
                    onConfirm={submit_forms}
                    // onConfirm={submit_all_form}
                    onCancel={cancel}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button
                      type="primary"
                      style={{ width: "100%" }}
                      onClick={getAllFormData}
                    >
                      Submit
                    </Button>
                  </Popconfirm>
                </Col>
                <Col span={12}>
                  <Button type="primary" style={{ width: "100%" }}>
                    Cancel
                  </Button>
                </Col>
              </Row>
            ) : (
              ""
            )}
          </Spin>
        )}
      </div>
    </div>
  );
};
export default SupervisorViewList;
